export default "__VITE_ASSET__B2N_IUtH__"